<template>
    <div class="jump-warphd nav-bar-fixed">
        <van-nav-bar title="审核列表" left-arrow fixed class="jump-nav-bar" @click-left="back" />
        <van-tabs v-model="tabActive" class="appr-tabs" @change="tabChange">
                <van-tab title="待审批" name="wait" style="position:relative">
                </van-tab>
               
                <van-tab title="已审批" name="already"></van-tab>
                <van-tab title="所有审批" name="all"></van-tab>
        </van-tabs>


                    <van-search class="appr-search"
                                v-model="searchV"
                                show-action
                    >
                        <van-button slot="action" @click="search" size="small" type="info">搜索</van-button>
                    </van-search>
                    <div class="appr-body">
                <van-list
                        v-model="loading"
                        :finished="finished"
                        finished-text="没有更多了"
                        @load="loadData"
                >
                <van-row class="jump-cart-item" v-for="item in list">
                    <van-row >
                        <van-col span="10" class="jump-cart-item-img">
                            <img :src="item.carts[0].imges"/>
                        </van-col>
                        <van-col span="14" class="jump-cart-item-warp">
                            <p class="item-time">{{item.submitTime | formatTime('yyyy-MM-dd')}} <span
                                    class="order-cancel">{{item.igoStatusName}}</span>
                            </p>
                            <p>申请人: {{item.apUserName}}</p>
                            <p>{{item.orderSn}}</p>
                        </van-col>
                        <van-col span="24" class="jump-cart-item-foot">
                            <van-button size="small" plain class="btn-cancel" @click="approval(item.id)"
                                        v-if="item.igoStatus == 20">
                                审批
                            </van-button>
                            <van-button size="small" plain class="btn-cancel" @click="seeOrder(item.id)">
                                查看详情
                            </van-button>
                        </van-col>
                    </van-row>
                </van-row>
            </van-list>
             </div>
        </div>
</template>
<script>
import {
  NavBar,
  Row,
  Col,
  Button,
  tab,
  tabs,
  Tab,
  Tabs,
  List,
  Search
} from "vant";

export default {
  name: "userIntegralOrder",
  components: {
    [NavBar.name]: NavBar,
    [Row.name]: Row,
    [Col.name]: Col,
    [Button.name]: Button,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [List.name]: List,
    [Search.name]: Search
  },
  data() {
    return {
      checkedAll: false,
      tabActive: 0,
      list: [],
      loading: false,
      finished: false,
      searchV: "",
      total: 0,
      page: 1,
      type: 0,
      flag: 1, //1.待我审核 2.已审核 3.所有
      params:{},
      num:'',//待审批数量
    };
  },
  methods: {
     tabChange(i){
        this.params.flag = i + 1;
        this.params.currentPage = 1;
        this.pages = 1;
        this.list = [];
        this.loadData();
    },
    search() {
        this.params.userName = this.searchV;
        this.params.orderSn = this.searchV;
        this.params.currentPage = 1;
        this.pages = 1;
        this.list = [];
        this.loadData();
    },
      loadData(){
        if(this.params.currentPage > this.pages){
          this.finished = true;
          this.loading = false;
          return;
        }
        this.finished = false;
        this.loading = true;
        this.selectList();
      },
      selectList(){
        let that = this;
        this.$api.post(that.jumuc.integral.auditOrderList,this.params,
          successRes =>{
            that.num=successRes.data.list.length;
            that.list =  that.list.concat(successRes.data.list);
            that.pages = successRes.data.pages;
            that.params.currentPage++;
            that.loading = false;
          })
      },
    back() {
      //history.back();
        this.$router.push({
            path: '/usercent'
        })
    },
    seeOrder(orderId) {
      this.$router.push({
        path: "/user/integral/order/detail",
        query: {
          id: orderId
        }
      });
    },
    approval(orderId) {
      let that = this;
      that.$router.push({
        path: "/user/integral/order/approval",
        query: {
          id: orderId
        }
      });
    }
  },
  mounted: function() {
    let that = this;
    this.params.flag =1;
    this.params.currentPage = 1;
    this.pages = 1;
    this.list = [];
  },
  filters: {
    formatTime: function(date, fmt) {
      var date = new Date(date.replace(/-/g, "/"));
      if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(
          RegExp.$1,
          (date.getFullYear() + "").substr(4 - RegExp.$1.length)
        );
      }
      var o = {
        "M+": date.getMonth() + 1,
        "d+": date.getDate(),
        "h+": date.getHours(),
        "m+": date.getMinutes(),
        "s+": date.getSeconds()
      };
      for (var k in o) {
        if (new RegExp("(" + k + ")").test(fmt)) {
          var str = o[k] + "";
          fmt = fmt.replace(
            RegExp.$1,
            RegExp.$1.length === 1 ? str : ("00" + str).substr(str.length)
          );
        }
      }
      return fmt;
    }
  }
};
</script>
<style lang="less" >
@bule-thame: #3c6eeb;

body {
  background-color: #f7f7f7;
}

button {
  margin: 5px;
}

.jump-cart {


  .van-hairline--bottom::after {
    border-bottom-width: 0px;
  }
  &-body {
    padding: 20px 10px 0;
    position: relative;
    &-hd {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 80px;
      background-color: @bule-thame;
    }
  }
  &-item {
    background-color: #fff;
    margin-bottom: 15px;
    align-items: center;
    border-radius: 20px;
    padding: 15px;
    position: relative;
    .van-checkbox {
      height: 100%;
      line-height: 100%;
    }
    &-img {
      img {
        width: 90%;
      }
    }

    h4 {
      font-size: 16px;
      padding: 10px 0;
    }
    &-warp {
      align-self: flex-start;
    }
    p {
      font-size: 14px;
      &.item-time {
        font-size: 14px;
        span {
          float: right;
          color: @bule-thame;
        }
        span.order-cancel {
          color: green;
        }
      }
      &.item-price {
        font-size: 14px;
        text-align: right;
      }
    }
    &-foot {
      padding: 10px 0;
      text-align: right;
      button {
        margin-left: 10px;
        padding: 0 10px;
        border-radius: 10px;
        color: #999;
        border-color: #999;
      }
      button.btn-cancel {
        color: @bule-thame;
        border-color: @bule-thame;
      }
    }
  }
}
body {
  background: #f7f7ff;
}

#app .van-tabs__line {
  height: 45px;
  background-color: rgba(255, 255, 255, 0.1);
}

.appr-tabs {
  .van-tab {
    color: #fff;
  }
  .van-tabs__nav {
    background-color: @bule-thame;
  }
  .van-hairline--top-bottom::after {
    border-width: 0;
  }
}

.jump-warphd {
  .appr-search {
    margin-bottom: 10px;
    .van-cell__value {
      border-bottom: 1px #f7f7f7 solid;
    }
    .van-button {
      background-color: @bule-thame;
      border-color: @bule-thame;
    }
  }
  .appr-body {
    padding: 0 10px;
  }
  .appr-item {
    padding: 10px;
    margin-bottom: 10px;
    background-color: #fff;

    p {
      padding: 4px 0;
      font-size: 14px;
      &.item-r {
        color: #ccc;
        text-align: right;
      }
      span {
        min-width: 60px;
        display: inline-block;
      }
    }
    &-head {
      border-bottom: 1px #f7f7f7 solid;
      &-hd {
        position: relative;
        /*padding-left: 40px;*/
        span {
          position: absolute;
          top: 0;
          left: -15px;
          padding: 0 8px;
          color: #fff;
          background-color: @bule-thame;
          font-size: 14px;
          border-radius: 0 10px 10px 0;
        }
      }
    }
    &-foot {
      border-top: 1px #f7f7f7 solid;
      p {
        color: #ccc;
      }
    }
  }
}
</style>

